import { Check, CircleAlert, View } from "lucide-react";
import { useState, useEffect } from "react";
import { CustomProperty } from "winslow-core";
import { validateEmail } from "../../uiHelpers";

type AppCustomPropertyEmailProps = {
    customProperty: CustomProperty;
    data: any;
    validate: boolean;
    onChange: (label: string, data: any) => void;
}

export const AppCustomPropertyEmail = ({customProperty, data, validate, onChange} : AppCustomPropertyEmailProps) => {

    const [value, setValue] = useState<string>(data as string || "");

    useEffect(() => {
        onChange(customProperty.label, value);
    }, [value]);

    return (
        <div className="app-custom-property-email">
            {/* <div className="app-custom-property-label">
                {customProperty.label}
            </div> */}
            <div className="app-custom-property-value">
               
                <input 
                    type="text"
                    name={customProperty.label}
                    value={value}
                    onChange={(event) => {
                        setValue(event.target.value);
                    }}
                />
                {validate && !value && customProperty.required &&
                    <div className="app-employee-record-error">
                        <Check size={16} color="red"/>
                    </div>
                }
                {validate && value && !validateEmail(value) &&
                    <div className="app-employee-record-error">
                        <CircleAlert size={16} color="green"/>
                    </div>
                }
            </div>
        </div>
    )
}
